export default __webpack_public_path__ + "fonts/90fe05d20293628c1a08f67f2d0b9655.woff2";